// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9f26ae5d","77":"36312a40","115":"a66fb7a3","222":"693493dd","280":"51d41e4f","354":"b0616c38","444":"f9db5d39","510":"a0330be3","563":"11470ce7","567":"40c72142","860":"374e2920","928":"f8a9c84c"}[chunkId] + ".chunk.js";
};